import React, {useEffect} from "react";
import {Accordion, AccordionDetails, AccordionSummary, Button, CardMedia, Grid, TextField} from "@mui/material";
import {withStyles} from "@mui/styles";
import {connect} from "react-redux";
import {actions as eventsOverviewActions, selectors as eventsOverviewSelectors} from '../../../../Ducks/eventsOverview';
import {actions as contactsActions, selectors as ContactsSelectors} from "../../../../Ducks/contacts";
import {actions as opportunityActions, selectors as opportunitySelectors} from "../../../../Ducks/opportunity";
import {bindActionCreators} from "redux";
import CircularProgress from "@mui/material/CircularProgress";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LanguageIcon from '@mui/icons-material/Language';
import {ChevronLeft, Email, ExpandMore, LinkedIn, Mail, PhoneAndroid, PhoneForwarded} from '@mui/icons-material';
import {useParams} from "react-router-dom";
import moment from "moment";
import {ERP_BASE_URL} from "../../../../API/util";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import NextPlannedAction from "../Widgets/NextPlannedAction";
import {isEmpty} from 'lodash';
import ParticipantPurchases from "../../../Common/Overview/ParticipantPurchases";
import logo from "../../../../Assets/icons/f5-logo.svg";
import FollowUp from "../../../Common/Widgets/FollowUp";
import PersonJobOverview from "../../../Common/Widgets/PersonJobOverview";
import PersonHistory from "../../../Common/Widgets/PersonHistory";
import PersonConfigurationHistoryTooltip from "../../../Common/PersonConfigurationHistoryTooltip";

const useStyles = (_theme) => ({
    title: {
        display: 'flex !important',
        alignItems: 'center !important'
    },
    card: {
        display: "flex !important",
        backgroundColor: "#fff !important",
    },
    cardMedia: {
        flex: 1,
        width: "85px",
        backgroundColor: "#F1F1F1",
    },
    cardContent: {
        flex: 4,
        padding: '16px'
    },
    flexVertical: {
        display: "flex",
        alignItems: "center",
    },
    flexCenter: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    inputField: {
        flex: 1
    },
    fieldSet: {
        display: 'flex',
        alignItems: 'end'
    },
    flex: {
        display: 'flex'
    },
    sendout: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    send: {
        background: 'green',
        width: '14px',
        height: '14px',
        marginRight: '5px',
    },
    sent: {
        background: '#2785e6',
        width: '14px',
        height: '14px',
        marginRight: '5px',
        borderStyle: 'dashed'
    },
    notsent: {
        width: '14px',
        height: '14px',
        marginRight: '5px',
        borderStyle: 'solid'
    },
    noBgDotted: {
        width: '19px',
        height: '19px',
        marginRight: '5px',
        background: 'repeating-linear-gradient(45deg, red, red 2px, transparent 2px, transparent 8px)',
        border: 'red',
        borderStyle: 'solid'
    },
    lightBlueBgDotted: {
        width: '19px',
        height: '19px',
        marginRight: '5px',
        background: 'repeating-linear-gradient(45deg, red, red 2px, #5cd7ff 2px, #5cd7ff 8px)',
        borderStyle: 'solid',
        borderColor: 'red'
    },
    lightBlueBgSolid: {
        background: '#5cd7ff',
        width: '19px',
        height: '19px',
        marginRight: '5px',
        borderStyle: 'solid',
        borderColor: '#42d142'

    },
    lightBlueBg: {
        background: '#5cd7ff',
        width: '19px',
        height: '19px',
        marginRight: '5px',
    },
    darkBlueBgSolid: {
        background: '#0047ab',
        width: '19px',
        height: '19px',
        marginRight: '5px',
        borderStyle: 'solid',
        borderColor: '#42d142'
    },
    darkBlueBg: {
        background: '#0047ab',
        width: '19px',
        height: '19px',
        marginRight: '5px'
    },
    darkBlueBgDotted: {
        width: '19px',
        height: '19px',
        marginRight: '5px',
        borderStyle: 'solid',
        borderColor: 'red',
        background: 'repeating-linear-gradient(45deg, red, red 2px, #0047ab 2px, #0047ab 8px)'
    },
    noBgSolid: {
        background: 'transparent',
        width: '19px',
        height: '19px',
        marginRight: '5px',
        borderStyle: 'solid'
    },
    cyanBgSolid: {
        background: '#FDDA0D',
        width: '19px',
        height: '19px',
        marginRight: '5px',
    },
    cyanBg: {
        background: '#FDDA0D',
        width: '19px',
        height: '19px',
        marginRight: '5px',
    },
    grayBg: {
        background: '#757373',
        width: '19px',
        height: '19px',
        marginRight: '5px',
    },
    empty: {
        width: '19px',
        height: '19px',
        marginRight: '5px',
        borderStyle: 'solid',
        borderColor: '#cacaca'
    },
    completed: {
        width: '19px',
        height: '19px',
        marginRight: '5px',
        borderStyle: 'solid',
        borderColor: 'green',
        background: 'green'
    },
    changed: {
        width: '19px',
        height: '19px',
        marginRight: '5px',
        borderStyle: 'solid',
        borderColor: 'red',
        background: 'green'
    },
    failed: {
        width: '19px',
        height: '19px',
        marginRight: '5px',
        borderStyle: 'solid',
        borderColor: 'red',
        background: 'red'
    },
    attending: {
        background: '#68a54d !important',
        color: '#fff !important',
        '&:hover': {
            background: '#68a54d !important',
        }
    },
    not_attending: {
        background: '#db6669 !important',
        color: '#fff !important',
        '&:hover': {
            background: '#db6669 !important',
        }
    },
    unknown: {
        background: '#7f7f7f !important',
        color: '#fff !important',
        '&:hover': {
            background: '#7f7f7f !important',
        }
    },
    tentative: {
        background: '#f9fd01 !important',
        color: '#000 !important',
        '&:hover': {
            background: '#f9fd01 !important',
        }
    },
    appeared: {
        background: '#2785e6',
        width: '14px',
        height: '14px',
        marginRight: '5px',
        borderStyle: 'solid'
    },
    nothing: {
        background: '#2785e6',
        width: '14px',
        height: '14px',
        marginRight: '5px',
    },
    happened: {
        background: 'green',
        width: '14px',
        height: '14px',
        marginRight: '5px',
    },
    notHappened: {
        width: '14px',
        height: '14px',
        marginRight: '5px',
        borderStyle: 'solid'
    },
    answer: {
        background: '#1976d2',
        color: '#fff',
        '&:hover': {
            color: '#000'
        }
    },
    accordionSummary: {
        '& > div': {
            flexDirection: 'column'
        }
    },
    historyCount: {
        background: 'red',
        borderRadius: '50%',
        color: '#fff',
        fontSize: '12px',
        marginLeft: '5px',
        width: '25px',
        height: '25px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    panel: {
        backgroundColor: '#fff',
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
        position: "relative",
        transition: " margin 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
        overflowAnchor: "none",
        borderRadius: 0,
        padding: "15px"
    },
    checkbox: {
        width: "15px",
        height: "15px",
        cursor: "pointer"
    },
    personTable: {
        '& > tbody > tr > td': {
            padding: '5px',
            minWidth: '160px'
        }
    }
});

const personColumns = [
    "person_id",
    "erp_client_id",
    "region_id",
    "person_token",
    "person_firstname",
    "person_lastname",
    "person_never_contact",
    "person_mobile_number",
    "person_preferences_never_text",
    "person_preferences_limit_calls",
    "person_linkedin_url",
    "person_linkedin_member_id",
    "person_challenges",
    "person_food_considerations",
    "person_special_conditions",
    "person_industry",
    "person_country",
    "person_region",
    "person_language",
    "person_gender",
    "lead_source",
    "lead_target_id",
    "sf_person_id",
    "person_created_at",
    "person_last_update",
    "person_awaiting_sync",
    "person_last_sync",
    "person_flagged_from_salesview",
    "person_preferences_pause_sendouts",
    "email_verified_at",
];

const PersonOverviewTab = (props) => {
    const {
        classes,
        person,
        eventInfo,
        getContactDetails,
        contactDetails,
        getJobs,
        jobs,
        getPersonPurchases,
        personPurchases,
        getPersonOpportunities,
        personOpportunities,
        getParticipantDetails,
        personHistory,
        foodConsiderations,
        isNetworkDirector,
        getPersonOpenOpportunity,
        personOpenOpportunity,
    } = props;

    const [personDetails, setPersonDetails] = React.useState({});
    const [primaryJob, setPrimaryJob] = React.useState(null);
    const [expanded, setExpanded] = React.useState('panel4');
    const [isOpen, setIsOpen] = React.useState(false);
    const [neverContact, setNeverContact] = React.useState(false);
    const [neverSms, setNeverSms] = React.useState(false);
    const [limitCalls, setLimitCalls] = React.useState(false);
    const [limitEmails, setLimitEmails] = React.useState(false);
    const [personChallenges, setPersonChallenges] = React.useState("");
    const [personFoodConsiderations1, setPersonFoodConsiderations1] = React.useState("");
    const [personFoodConsiderations2, setPersonFoodConsiderations2] = React.useState([]);
    const [personFoodConsiderationsOther, setPersonFoodConsiderationsOther] = React.useState("");
    const [personPielineStage, setPersonPielineStage] = React.useState("");
    const [pauseSendouts, setPauseSendouts] = React.useState(false);

    useEffect(() => {
        props.getFoodConsiderations();
    }, [])

    useEffect(() => {
        if (person !== null && person !== undefined) {
            getContactDetails({id: person.person_id, columns: personColumns});
            getJobs(person.person_id);
            getPersonOpenOpportunity(person.person_id);
            getPersonPurchases(person.person_id);
            getPersonOpportunities(person.person_id);
        }

        if ((person !== null && person !== undefined) && (eventInfo !== null && eventInfo !== undefined)) {
            getParticipantDetails({event_id: eventInfo.event_id, participant_id: person.potential_participant_id});
        }

    }, [person, eventInfo]);

    useEffect(() => {
        if (contactDetails !== null && contactDetails !== undefined) {
            setPersonDetails(contactDetails.main[0]);

            // set checkboxes
            setNeverContact(contactDetails.main[0].person_never_contact);
            setNeverSms(contactDetails.main[0].person_preferences_never_text);
            setLimitCalls(contactDetails.main[0].person_preferences_limit_calls);
            setLimitEmails(contactDetails.main[0].person_preferences_limit_emails);
            setPauseSendouts(contactDetails.main[0].person_preferences_pause_sendouts);

            // set fields
            setPersonChallenges(contactDetails.main[0].person_challenges);
            setPersonFoodConsiderations1(contactDetails.main[0].person_food_considerations_1 ? contactDetails.main[0].person_food_considerations_1 : "");
            setPersonFoodConsiderations2(contactDetails.main[0].person_food_considerations_2 ? contactDetails.main[0].person_food_considerations_2 : []);
            setPersonFoodConsiderationsOther(contactDetails.main[0].person_food_considerations_other ? contactDetails.main[0].person_food_considerations_other : "");
        }
    }, [contactDetails]);

    useEffect(() => {
        let _primaryJob = jobs?.main.filter((item) => item.job_is_primary === 1);

        if (_primaryJob?.length > 0) {
            setPrimaryJob(_primaryJob);
        }
    }, [jobs]);

    useEffect(() => {
        if (personOpenOpportunity) {
            if (personOpenOpportunity.pipeline_stages?.length) {
                let _pipelineStage = personOpenOpportunity.pipeline_stages.filter((item) => item.pipeline_stage_id === personOpenOpportunity.pipeline_stage_id);

                setPersonPielineStage(_pipelineStage[0]);
            }
        }
    }, [personOpenOpportunity])

    const showProgress = () => (
        <div style={{display: "flex", justifyContent: "center"}}>
            <CircularProgress/>
        </div>
    );

    if (!person) {
        return showProgress();
    }

    const handleChange = (panel) => (_event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "person_never_contact") {
            setNeverContact(value);
        }

        if (name === "person_preferences_never_text") {
            setNeverSms(value);
        }

        if (name === "person_preferences_limit_calls") {
            setLimitCalls(value);
        }

        if (name === "person_preferences_limit_emails") {
            setLimitEmails(value);
        }

        if (name === "person_preferences_pause_sendouts") {
            setPauseSendouts(value);
        }

        props.updateContact({
            id: person.person_id,
            obj: {[name]: value}
        });
    }

    const saveInfo = (field) => {
        if (field === "person_challenges") {
            props.updateContact({
                id: person.person_id,
                obj: {person_challenges: personChallenges}
            });
        }
        if (field === "person_food_considerations") {
            if (personFoodConsiderationsOther === "") {
                props.updateContact({
                    id: person.person_id,
                    obj: {
                        person_food_considerations_1: personFoodConsiderations1,
                        person_food_considerations_2: personFoodConsiderations2
                    }
                });
            } else {
                props.updateContact({
                    id: person.person_id,
                    obj: {
                        person_food_considerations_1: personFoodConsiderations1,
                        person_food_considerations_2: personFoodConsiderations2,
                        person_food_considerations_other: personFoodConsiderationsOther
                    }
                });
            }
        }
    }

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{marginBottom: "10px"}}>
                    <Card className={classes.card}>
                        <CardMedia
                            className={classes.cardMedia}
                            component="img"
                            alt=""
                            image={`${ERP_BASE_URL}/uploads/images/persons/${personDetails.person_token}.jpg`}
                        />
                        <CardContent className={classes.cardContent}>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <Typography variant="h6" component="div">
                                        {personDetails.person_firstname} {personDetails.person_lastname}
                                    </Typography>
                                    {
                                        personDetails.title && (
                                            <Typography variant="body2" color="site.main">
                                                <BusinessCenterIcon sx={{color: 'icon.main', fontSize: "20px"}}/>
                                                <span style={{marginLeft: '8px'}}>{personDetails.title}</span>
                                            </Typography>
                                        )
                                    }
                                    {
                                        personDetails.person_region && (
                                            <Typography variant="body2" color="site.main" className={classes.flexVertical}>
                                                <LanguageIcon sx={{color: 'icon.main', fontSize: "20px"}}/>
                                                <span style={{marginLeft: '8px'}}>{personDetails.person_region}</span>
                                            </Typography>
                                        )
                                    }
                                </div>
                            </div>
                            <div className={classes.flexCenter}>
                                {
                                    personDetails.mobile &&
                                    <Typography variant="body2" color="site.main">
                                        <a href={`callto:${personDetails.mobile}`} onClick={props.showActiveTab}
                                           style={{
                                               textDecoration: 'none',
                                               color: 'inherit',
                                               display: 'flex',
                                               alignItems: 'center'
                                           }}>
                                            <PhoneAndroid sx={{color: 'icon.main', fontSize: "20px"}}/>
                                            <span style={{marginLeft: '8px'}}>
                                                {personDetails.mobile}
                                            </span>
                                        </a>
                                    </Typography>
                                }
                                {
                                    personDetails.email &&
                                    <Typography variant="body2" color="site.link">
                                        <a href={`mailto:${personDetails.email}`} style={{
                                            textDecoration: 'none',
                                            color: 'inherit',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            <Email sx={{color: 'icon.main', fontSize: "20px"}}/>
                                            <span style={{marginLeft: '8px'}}>
                                                {personDetails.email}
                                            </span>
                                        </a>
                                    </Typography>
                                }
                            </div>
                            <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end'}}>
                                <Typography variant="body2" color="site.main">
                                    <a target="_blank" href={personDetails.person_linkedin_url}
                                       rel="noreferrer"><LinkedIn
                                        sx={{color: 'icon.linkedin', fontSize: "44px"}}/></a>
                                </Typography>
                                <Typography variant="body2" color="site.main">
                                    <a target="_blank"
                                       href={`${ERP_BASE_URL}/#/contacts/persons/${personDetails.person_id}`}
                                       rel="noreferrer">
                                        <img alt="" src={logo} className="logo-link"></img>
                                    </a>
                                </Typography>
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12}>
                    <Box mb={2}>
                        <Box className={classes.panel}>
                            <Box sx={{display: 'flex', justifyContent: "space-between", alignItems: 'center'}}>
                                <Typography variant="h1" component="h5" sx={{fontSize: '18px', fontWeight: '500'}}>
                                    Personal Details
                                </Typography>
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    textAlign: 'center'
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginRight: '10px'
                                    }}>
                                        <PhoneAndroid sx={{marginRight: '5px', fontSize: '14px'}}/> <a
                                        style={{textDecoration: 'none', fontSize: '14px'}}
                                        href={`callto:${personDetails.person_mobile_number}`}>{personDetails.person_mobile_number}</a>
                                    </Box>
                                    {
                                        primaryJob?.length > 0 && (
                                            <>
                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    marginRight: "10px"
                                                }}>
                                                    {
                                                        primaryJob[0].job_phone && (
                                                            <>
                                                                <PhoneForwarded
                                                                    sx={{marginRight: '5px', fontSize: '14px'}}/> <a
                                                                style={{textDecoration: 'none', fontSize: '14px'}}
                                                                href={`callto:${primaryJob[0].job_phone}`}>{primaryJob[0].job_phone}</a>
                                                            </>
                                                        )
                                                    }
                                                </Box>
                                                <Box sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                }}>
                                                    <Mail sx={{marginRight: '5px', fontSize: '14px'}}/> <a
                                                    style={{textDecoration: 'none', fontSize: '14px'}}
                                                    href={`mailto:${primaryJob[0].job_email}`}>{primaryJob[0].job_email}</a>
                                                </Box>
                                            </>
                                        )
                                    }
                                </Box>
                                <Box sx={{display: 'flex', justifyContent: 'flex-end', minWidth: '100px'}}>
                                    <ChevronLeft sx={{cursor: 'pointer'}} className={isOpen ? "showUP" : "showDown"}
                                                 onClick={() => setIsOpen(!isOpen)}/>
                                </Box>
                            </Box>
                        </Box>
                        {
                            isOpen &&
                            <Box className={classes.panel}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <table className={classes.personTable} style={{width: '100%'}}>
                                                    <tbody>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Gender
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{
                                                                fontSize: '14px',
                                                                margin: 0,
                                                                textTransform: 'capitalize'
                                                            }}>
                                                                {personDetails.person_gender}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    {
                                                        !isNetworkDirector && (
                                                            <>
                                                                <tr>
                                                                    <td>
                                                                        <Typography variant="h1" component="h5" sx={{
                                                                            fontSize: '14px',
                                                                            fontWeight: 'bold'
                                                                        }}>
                                                                            Challenges
                                                                        </Typography>
                                                                    </td>
                                                                    <td>
                                                                        <div
                                                                            style={{display: 'flex', alignItems: 'center'}}>
                                                                            <TextField
                                                                                type="text"
                                                                                id="person_challenges"
                                                                                label=""
                                                                                variant="outlined"
                                                                                size="small"
                                                                                style={{width: '90%'}}
                                                                                value={personDetails?.person_challenges}
                                                                                disabled={true}
                                                                            ></TextField>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <Typography variant="h1" component="h5" sx={{
                                                                            fontSize: '14px',
                                                                            fontWeight: 'bold'
                                                                        }}>
                                                                            Food Considerations
                                                                        </Typography>
                                                                    </td>
                                                                    <td>
                                                                        <FormControl sx={{
                                                                            minWidth: 120,
                                                                            width: '49%',
                                                                            marginRight: '1%'
                                                                        }} size="small">
                                                                            <InputLabel
                                                                                id="person_food_considerations_1">Type</InputLabel>
                                                                            <Select
                                                                                labelId="person_food_considerations_1"
                                                                                id="person_food_considerations_1"
                                                                                value={personFoodConsiderations1}
                                                                                label="Type"
                                                                                onChange={(e) => {
                                                                                    setPersonFoodConsiderations1(e.target.value)
                                                                                }}
                                                                            >
                                                                                <MenuItem value="">-- Select
                                                                                    Type--</MenuItem>
                                                                                {foodConsiderations && foodConsiderations.type1_food.map((item) => (
                                                                                    <MenuItem
                                                                                        key={item.id}
                                                                                        value={item.id}
                                                                                    >
                                                                                        {item.title}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                        </FormControl>
                                                                        <FormControl sx={{minWidth: 120, width: '50%'}}
                                                                                     size="small">
                                                                            <InputLabel
                                                                                id="person_food_considerations_2">Allergy</InputLabel>
                                                                            <Select
                                                                                labelId="person_food_considerations_2"
                                                                                id="person_food_considerations_2"
                                                                                multiple
                                                                                value={personFoodConsiderations2}
                                                                                onChange={(e) => {
                                                                                    setPersonFoodConsiderations2(e.target.value);
                                                                                    if (!e.target.value.includes(16)) {
                                                                                        setPersonFoodConsiderationsOther("")
                                                                                    }
                                                                                }}
                                                                                input={<OutlinedInput label="Name"/>}
                                                                            >
                                                                                {foodConsiderations && foodConsiderations.type2_food.map((item) => (
                                                                                    <MenuItem
                                                                                        key={item.id}
                                                                                        value={item.id}
                                                                                    >
                                                                                        {item.title}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                        </FormControl>
                                                                        {
                                                                            personFoodConsiderations2.includes(16) && (
                                                                                <TextField
                                                                                    type="text"
                                                                                    id="food_consideration_other"
                                                                                    name="food_consideration_other"
                                                                                    label="Other"
                                                                                    variant="outlined"
                                                                                    size="large"
                                                                                    style={{marginTop: '10px', width: '100%'}}
                                                                                    value={personFoodConsiderationsOther}
                                                                                    onChange={(e) => {
                                                                                        setPersonFoodConsiderationsOther(e.target.value);
                                                                                    }}
                                                                                ></TextField>
                                                                            )
                                                                        }
                                                                        <Button
                                                                            color="primary"
                                                                            variant="contained"
                                                                            sx={{
                                                                                display: 'block',
                                                                                width: '100%',
                                                                                marginTop: '10px'
                                                                            }}
                                                                            onClick={() => saveInfo('person_food_considerations')}
                                                                        >
                                                                            Save
                                                                        </Button>
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )
                                                    }
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Special Conditions
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                {personDetails.person_special_conditions}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Mobile Number
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                <a href={`callto:${personDetails.person_mobile_number}`}>{personDetails.person_mobile_number}</a>
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Connections Count
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                {personDetails.person_li_connection_count}
                                                            </Typography>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Never Contact

                                                                <PersonConfigurationHistoryTooltip
                                                                    personDetails={personDetails}
                                                                    fieldName="person_never_contact_history_note"
                                                                />
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                <input
                                                                    name="person_never_contact"
                                                                    type="checkbox"
                                                                    checked={neverContact}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                    disabled={isNetworkDirector}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Never SMS

                                                                <PersonConfigurationHistoryTooltip
                                                                    personDetails={personDetails}
                                                                    fieldName="person_preferences_never_text_history_note"
                                                                />
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                <input
                                                                    name="person_preferences_never_text"
                                                                    type="checkbox"
                                                                    checked={neverSms}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                    disabled={isNetworkDirector}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Limit Calls

                                                                <PersonConfigurationHistoryTooltip
                                                                    personDetails={personDetails}
                                                                    fieldName="person_preferences_limit_calls_history_note"
                                                                />
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                <input
                                                                    name="person_preferences_limit_calls"
                                                                    type="checkbox"
                                                                    checked={limitCalls}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                    disabled={isNetworkDirector}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Limit Emails
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                <input
                                                                    name="person_preferences_limit_emails"
                                                                    type="checkbox"
                                                                    checked={limitEmails}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                    disabled={isNetworkDirector}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant='h1' component='h5'
                                                                        sx={{fontSize: "14px", fontWeight: "bold"}}>
                                                                Pause Sendouts

                                                                <PersonConfigurationHistoryTooltip
                                                                    personDetails={personDetails}
                                                                    fieldName="person_preferences_pause_sendouts_history_note"
                                                                />
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: "14px", margin: 0}}>
                                                                <input
                                                                    name='person_preferences_pause_sendouts'
                                                                    type='checkbox'
                                                                    checked={pauseSendouts}
                                                                    onChange={handleInputChange}
                                                                    className={classes.checkbox}
                                                                    disabled={isNetworkDirector}
                                                                />
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                CC Email
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                <a href={`mailto:${personDetails.person_cc_email}`}>{personDetails.person_cc_email}</a>
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                LinkedIn MemberID
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                {personDetails.person_linkedin_member_id}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Lead Source
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                {personDetails.lead_source}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Typography variant="h1" component="h5"
                                                                        sx={{fontSize: '14px', fontWeight: 'bold'}}>
                                                                Last Scrape Time
                                                            </Typography>
                                                        </td>
                                                        <td>
                                                            <Typography sx={{fontSize: '14px', margin: 0}}>
                                                                {personDetails.person_last_scrape_time}
                                                            </Typography>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        }
                    </Box>
                </Grid>
                {
                    personOpenOpportunity && !isNetworkDirector && !isEmpty(personOpenOpportunity) && (
                        <Grid item xs={12}>
                            <Card className={classes.card}>
                                <CardContent className={classes.cardContent}>
                                    <NextPlannedAction opportunity={personOpenOpportunity} person={person}/>

                                    <div style={{
                                        borderTop: '1px solid #c8c8c8',
                                        padding: '10px 0',
                                        margin: '10px 0 0'
                                    }}></div>

                                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <div style={{marginRight: '10px', display: 'flex', flexDirection: 'column'}}>
                                            <span>
                                                <b>Current Open Opportunity:</b> {personOpenOpportunity && personOpenOpportunity.opportunity_id ?
                                                <a href={`${window.location.origin}/opportunities/id/${personOpenOpportunity ? personOpenOpportunity.opportunity_id : undefined}`}
                                                   target="_blank">{personOpenOpportunity && personOpenOpportunity.opportunity_id}</a> : "None"}
                                            </span>
                                            <span
                                                style={{fontSize: '15px'}}>({personOpenOpportunity && personOpenOpportunity.sales_rep_name})</span>
                                        </div>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <Typography component="span" style={{marginRight: '10px'}}>
                                                <b>Pipeline Stage:</b>{personPielineStage.pipeline_stage_title}
                                            </Typography>
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </Grid>
                    )
                }
                {
                    !isNetworkDirector && (
                        <Grid item xs={12}>
                            <Accordion>
                                <AccordionSummary expandIcon={<ExpandMore/>} aria-controls='panel5a-content'
                                                  id='panel5a-header'>
                                    Follow Ups
                                </AccordionSummary>
                                <AccordionDetails sx={{background: "#ffffff"}}>
                                    <FollowUp person={personDetails}
                                              jobEmail={primaryJob} hideTitle={true}/>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    )
                }
                <Grid item xs={12}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>}
                            aria-controls='panel2a-content'
                            id='panel2a-header'
                            className={classes.accordionSummary}
                        >
                            <Typography variant='h1' component='h5'
                                        sx={{
                                            fontSize: "18px",
                                            fontWeight: "500",
                                            marginBottom: "10px",
                                            textAlign: 'left'
                                        }}>
                                Jobs
                            </Typography>
                            {primaryJob?.length > 0 &&
                                <PersonJobOverview job={primaryJob[0]} companies={jobs.related_objects.companies}/>
                            }
                        </AccordionSummary>
                        <AccordionDetails>
                            {jobs &&
                                jobs.main
                                    .filter((item) => !item.job_is_primary)
                                    .map((job, _index) => (
                                        <PersonJobOverview job={job} companies={jobs.related_objects.companies}/>))}
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <ParticipantPurchases
                        classes={classes}
                        personPurchases={personPurchases}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>}
                            aria-controls="panel3a-content"
                            id="panel3a-header"
                        >
                            <Typography variant="h1" component="h5"
                                        sx={{fontSize: '18px', fontWeight: '500'}}>
                                Opportunities
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {personOpportunities && personOpportunities.map((opportunity, index) => {
                                return (
                                    <Grid key={index} container spacing={2}
                                          sx={{padding: '10px 0', borderTop: '1px solid #c2c2c2', marginTop: 0}}>
                                        <Grid item xs={6} sx={{paddingTop: '0 !important'}}>
                                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                                <Typography style={{fontSize: '13px'}} gutterBottom variant="h6"
                                                            component="div">
                                                    {opportunity.product_name}
                                                </Typography>
                                                <Typography
                                                    style={{flexGrow: "1", fontSize: '11px'}}
                                                    gutterBottom
                                                    variant="span"
                                                    component="span"
                                                >
                                                    {opportunity.product_type_name}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={2} sx={{paddingTop: '0 !important'}}>
                                            <Typography style={{fontSize: '13px'}} gutterBottom variant="h6"
                                                        component="div">
                                                {opportunity.opportunity_status}
                                            </Typography>

                                        </Grid>
                                        <Grid item xs={2} sx={{paddingTop: '0 !important'}}>

                                            <Typography
                                                style={{padding: "0 10px 0 0", fontSize: '13px'}}
                                                gutterBottom
                                                className={classes.typography}
                                                variant="span"
                                                component="span"
                                            >
                                                {opportunity.opportunity_type}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={2} sx={{paddingTop: '0 !important'}}>

                                            <Typography
                                                style={{padding: "0 10px 0 0", fontSize: '13px'}}
                                                gutterBottom
                                                className={classes.typography}
                                                variant="span"
                                                component="span"
                                            >
                                                {moment(opportunity.opportunity_creation_time).format("DD/MM/YYYY hh:mm")}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                );
                            })}
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                <Grid item xs={12}>
                    <Accordion expanded={expanded === "panel4"} onChange={handleChange('panel4')}>
                        <AccordionSummary
                            expandIcon={<ExpandMore/>}
                            aria-controls="panel4a-content"
                            id="panel4a-header"
                        >
                            <Typography variant="h1" component="h5" sx={{
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '18px',
                                fontWeight: '500'
                            }}>
                                History <span
                                className={classes.historyCount}>{personHistory && personHistory.length}</span>
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{background: "#efefef"}}>
                            <PersonHistory person={personDetails} isNetworkDirector={isNetworkDirector}
                                           hideAddEntry={true}/>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
        </>
    );
};

const mapStateToProps = (state) => ({
    errorMessage: eventsOverviewSelectors.errorMessage(state),
    personPurchases: eventsOverviewSelectors.personPurchases(state),
    personOpportunities: eventsOverviewSelectors.personOpportunities(state),
    participantDetails: eventsOverviewSelectors.participantDetails(state),
    contactDetails: ContactsSelectors.contactDetails(state),
    foodConsiderations: ContactsSelectors.foodConsiderations(state),
    jobs: opportunitySelectors.jobs(state),
    personHistory: eventsOverviewSelectors.personHistory(state),
    personOpenOpportunity: eventsOverviewSelectors.personOpenOpportunity(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updateSendoutEmail: eventsOverviewActions.updateSendoutEmail,
            updatePersonStage: eventsOverviewActions.updatePersonStage,
            getPersonPurchases: eventsOverviewActions.getPersonPurchases,
            getPersonOpenOpportunity: eventsOverviewActions.getPersonOpenOpportunity,
            getPersonOpportunities: eventsOverviewActions.getPersonOpportunities,
            getParticipantDetails: eventsOverviewActions.getParticipantDetails,
            getContactDetails: contactsActions.getContactDetails,
            getFoodConsiderations: contactsActions.getFoodConsiderations,
            getJobs: opportunityActions.getJobs,
            updateContact: contactsActions.updateContact
        },
        dispatch
    );

function WithNavigate(props) {
    let params = useParams();
    return <PersonOverviewTab {...props} params={params}/>
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(useStyles)(WithNavigate));
